import React from 'react';
import { useTranslation } from 'react-i18next/';
import { faHeart } from '@fortawesome/pro-regular-svg-icons';

import styles from './BucketListBlock.module.scss';
import Props from './BucketListBlock.props';
import BucketListBlockItem from '@components/ui/BucketListBlockItem/BucketListBlockItem';
import TitleCard from '@components/ui/TitleCard/TitleCard';

const NoItemsMessage = ({ message }: { message: string }) => (
  <p data-testid="NoItemsMessage">{message}</p>
);

const BucketListBlock = ({ items }: Props) => {
  const { t } = useTranslation();

  const RenderListItems = () => {
    return items.map((item) => (
      <BucketListBlockItem key={item.id} {...item} className={styles.BucketListBlockItem} />
    ));
  };

  return (
    <TitleCard
      title={t('DOMAIN.ACCOUNT.MY_BUCKETLIST')}
      icon={faHeart}
      titleStyle="FullWidth"
      size="sm"
      className={styles.TitleCard}>
      <div className={styles.BucketListBlock}>
        {items?.length > 0 ? (
          RenderListItems()
        ) : (
          <NoItemsMessage message={t('COMPONENTS.BUCKET_LIST_BLOCK.NO_ITEMS')} />
        )}
      </div>
    </TitleCard>
  );
};

export default BucketListBlock;
